module.exports = __webpack_public_path__ + "static/ver2-cf3ee17fc3e778018fd8e5584b85d1c0.jpg";